(() => {
  'use strict';
  const keys = ['photo_city','photo_type','photo_date','photo_from','photo_to','photo_subject','photo_orientation'];
  const types = ['photograph','enhanced','assisted','generated'];
  const normalize = value => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const day = value => {
    const date = new Date(value);
    if (!Number.isFinite(date.getTime())) return '';
    const parts = new Intl.DateTimeFormat('en-CA', {timeZone:'America/Los_Angeles',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(date);
    return ['year','month','day'].map(key => parts.find(part => part.type === key).value).join('-');
  };
  const dateInput = value => /^\d{4}-\d{2}-\d{2}$/.test(value || '') && Number.isFinite(Date.parse(value + 'T12:00:00Z')) && new Date(value + 'T12:00:00Z').toISOString().slice(0,10) === value;
  function fileKey(value) { try { return decodeURIComponent(new URL(value, 'https://desertoasisinsider.shop').pathname).split('/').pop().replace(/_(\d{2,4})x(?:\d{2,4})?(?=\.)/, ''); } catch { return ''; } }
  function registry(value) {
    const map = new Map();
    if (value?.version !== 1 || !Array.isArray(value.items) || value.items.length > 500) return map;
    for (const item of value.items) {
      if (!/^gid:\/\/shopify\/MediaImage\/\d+$/.test(item?.id) || !types.includes(item.classification)) continue;
      map.set(item.id.split('/').pop(), item);if(typeof item.fileKey==='string'&&item.fileKey)map.set(item.fileKey,item);
    }
    return map;
  }
  function metadata(photo, record, sourceCities = [], cities = []) {
    const text = normalize([photo.alt, photo.src].join(' ')).replace(/\bcoachella valley\b/g,'');
    const explicit = cities.filter(city => text.includes(normalize(city)));
    const location = record?.location ? [record.location] : explicit.length ? explicit : sourceCities.length === 1 ? sourceCities : [];
    return {...photo, cities: [...new Set(location)], classification:types.includes(record?.classification) ? record.classification : 'unclassified', detail:record?.detail || '', addedDay:record?.uploadedAt ? day(record.uploadedAt) : '', date:record?.uploadedAt ? Date.parse(record.uploadedAt) || 0 : 0};
  }
  function orientation(photo) {
    if (!(photo.width > 0 && photo.height > 0)) return '';
    const ratio = photo.width / photo.height;
    return ratio > 1.05 ? 'landscape' : ratio < .95 ? 'portrait' : 'square';
  }
  function matches(photo, filters, subjectMatch, now = Date.now()) {
    if (filters.photo_city && (filters.photo_city === '__unknown__' ? photo.cities?.length : !photo.cities?.includes(filters.photo_city))) return false;
    if (filters.photo_type && photo.classification !== filters.photo_type) return false;
    if (filters.photo_orientation && orientation(photo) !== filters.photo_orientation) return false;
    if (filters.photo_subject && !subjectMatch(photo, filters.photo_subject)) return false;
    if (filters.photo_date) {
      if (!photo.addedDay) return false;
      const today = day(now);
      if (filters.photo_date === 'custom') {
        if (filters.photo_from && dateInput(filters.photo_from) && photo.addedDay < filters.photo_from) return false;
        if (filters.photo_to && dateInput(filters.photo_to) && photo.addedDay > filters.photo_to) return false;
      } else {
        const days = Number(filters.photo_date);
        if (![7,30,365].includes(days)) return false;
        const from = new Date(Date.parse(today + 'T12:00:00Z') - (days - 1) * 86400000).toISOString().slice(0,10);
        if (photo.addedDay < from || photo.addedDay > today) return false;
      }
    }
    return true;
  }
  window.DOIImageFilters = {keys,types,day,dateInput,fileKey,registry,metadata,orientation,matches};
})();
